import { HttpInterceptorFn, HttpErrorResponse } from '@angular/common/http';
import { inject } from '@angular/core';
import { throwError } from 'rxjs';
import { catchError, retry } from 'rxjs/operators';
import { ToastService } from '@shared/services/toast/toast.service';
import { TranslateService, TranslatePipe } from '@ngx-translate/core';
import { Store } from '@ngrx/store';
import { MaintenanceActions } from '@features/maintenance/store/maintenance.actions';
import { UrlConfig } from '@shared/config/url.config';
import { SKIP_ERROR_TOAST } from './http-context.tokens';

export const errorInterceptor: HttpInterceptorFn = (req, next) => {
  const toastService = inject(ToastService);
  const translate = inject(TranslateService);
  const store = inject(Store);
  return next(req).pipe(
    retry(1),
    catchError((error: HttpErrorResponse) => {

      if (error.status !== 0 && error.status < 500 && !req.url.includes(`${UrlConfig.urlAdmin}maintenances`)) {
        store.dispatch(MaintenanceActions.loadMaintenance());
      }

      if (req.context.get(SKIP_ERROR_TOAST)) {
        return throwError(() => error);
      }

      if (error.status === 401) {
        toastService.showError(translate.instant('error.disconnected'));
      } else if (error.status === 400) {
        toastService.showErrorWithButton(error.error?.message);
      } else {
        toastService.showError(error.error?.message);
      }
      return throwError(() => error);
    })
  );
}
